export default "__VITE_ASSET__DRaZaouj__"